import { useMemo, useEffect } from 'react'
import { useAtom } from 'jotai'
import { Box, Heading, Divider, HStack } from '@chakra-ui/react'
import { TagSearchItem } from '@!/Store/Common/components/TagSearchList/TagSearchItem'
import { buildSearchUrl, getDevice } from '@!/Util'
import { breadcrumbAtom } from '@!/atoms/breadcrumbAtom'

export const Genres = ({ params }) => {
  const genres = params.genres || []
  const device = useMemo(() => getDevice(), [])
  const [, setBreadcrumb] = useAtom(breadcrumbAtom)

  useEffect(() => {
    setBreadcrumb([{ name: 'マンガBANGブックス', ref: '/' }, { name: 'ジャンル一覧' }])
  }, [setBreadcrumb])

  return (
    <Box px={4} py={6}>
      <Heading as="h1" fontSize="2xl">
        ジャンル一覧
      </Heading>

      <Divider mt={3} mb={4} />

      <HStack rowGap={4} columnGap={2} flexWrap="wrap" maxW="600px" m={device === 'pc' ? 'auto' : undefined} justify={device === 'pc' ? 'center' : undefined}>
        {genres.map((genre) => (
          <TagSearchItem key={genre} tag={genre} url={buildSearchUrl('category', genre)} />
        ))}
      </HStack>
    </Box>
  )
}
